import { NgModule } from "@angular/core";
import { MatButtonModule, MatDialogModule } from "@angular/material";
import { PageReusableComponentsModule, PopupLoaderModule, SharedModule } from "../../../../shared";

import { TechnitianInspectionSnoozeModalComponent } from "./technitian-inspection-snooze-modal.component";

@NgModule({
  declarations: [TechnitianInspectionSnoozeModalComponent],
  imports: [
    SharedModule,
    PopupLoaderModule,
    PageReusableComponentsModule,
    MatDialogModule,
    MatButtonModule,
  ],
  entryComponents: [TechnitianInspectionSnoozeModalComponent],
})
export class TechnicianInspectionSnoozeModalModule { }